export const convertStringifiedBooleanToBoolean = (value: undefined | boolean | string): boolean => (
  !!(value && value === 'true')
);
